module.exports = __webpack_public_path__ + "assets/img/joker.9a449cdf.png";